import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class BlockSliderAccompagnement {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.listing-accompagnement__swiper', {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 1.1,
      spaceBetween: 20,
      grabCursor: true,
      mousewheel: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        640: {
          slidesPerView: 2.1,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 3.2,
          spaceBetween: 24
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }
}

export const blockSliderAccompagnement = new BlockSliderAccompagnement();
